<template>
	<div class="dashboard-container">
		<main class="main-content">
			<aside class="left-panel">
				<!-- 设备分布布局 + 呼吸灯 -->
				<section class="panel-section panel-section1 breath-panel marquee-box marquee-panel">
					<h2 class="section-title">设备分布布局</h2>
					<div class="device-content">
						<div class="chart-wrapper">
							<div class="echarts-pie" ref="pieChart"></div>
						</div>
						<div class="legend-list">
							<div class="legend-item">
								<span class="dot normal"></span>
								<span class="label">正常设备</span>
								<span
									class="value">{{distribution.normalDeviceCount}}（{{distribution.normalDevicePercent}}%）</span>
							</div>
							<div class="legend-item">
								<span class="dot abnormal"></span>
								<span class="label">异常设备</span>
								<span
									class="value">{{distribution.abnormalDeviceCount}}（{{distribution.abnormalDevicePercent}}%）</span>
							</div>
							<div class="legend-item">
								<span class="dot video"></span>
								<span class="label">视频设备</span>
								<span
									class="value">{{distribution.videoDeviceCount}}（{{distribution.videoDevicePercent}}%）</span>
							</div>
							<div class="legend-item">
								<span class="dot offline"></span>
								<span class="label">离线设备</span>
								<span
									class="value">{{distribution.offlineDeviceCount}}（{{distribution.offlineDevicePercent}}%）</span>
							</div>
						</div>
					</div>
				</section>

				<!-- 重点区域 + 呼吸灯 -->
				<section class="panel-section panel-section2 breath-panel marquee-box marquee-panel">
					<div class="section-header">
						<h2 class="section-title">重点区域</h2>
						<span class="time-label">今日/24H</span>
					</div>
					<div class="tab-list">
						<div class="tab-item" @click="tabClick(item)" :class="{active:footerIndex == item.areaId}"
							v-for="(item,index) in area_overviewData.areas" :key="index">{{item.areaName}}</div>
					</div>

					<!-- 顶部数据卡片 + 呼吸灯 -->
					<div class="top-cards">
						<div class="top-card">
							<div class="card-num">{{onlineDeviceCount}}<span>个</span></div>
							<div class="card-desc">正常在线设备</div>
						</div>
						<div class="top-card">
							<div class="card-num">{{abnormalDeviceCount}}<span>个</span></div>
							<div class="card-desc">异常待整改</div>
						</div>
						<div class="top-card">
							<div class="card-num">{{factorsObj.cameraCount || 0}}</div>
							<div class="card-desc">视频监控资源</div>
						</div>
					</div>

					<!-- 环境数据网格 + 呼吸灯 -->
					<div class="data-grid">
						<div class="grid-item" :class="getFactorStatusClass(item)"
							v-for="(item,index) in factorsObj.factors" :key="index" @click="getDeviceCode(item)">
							<div class="item-header">
								<div class="title">{{item.factorName}}</div>
								<span class="tag">{{ isFactorAbnormal(item) ? '异常' : '实时' }}</span>
							</div>
							<div class="value">{{item.factorValue || 0}}{{ item.factorUnit }}</div>
							<!-- <div class="desc">{{item.factorValue}}</div> -->
						</div>
					</div>

					<!-- 温度折线图 -->
					<div class="chart-section">
						<div class="chart-tabs">
							<span :class="{tab:true,active:item.key == dateKey}" @click="dateClick(item.key)"
								v-for="(item,index) in dateData" :key="index">{{item.label}}</span>
						</div>
						<div class="echarts-line" ref="lineChart"></div>
					</div>
				</section>
			</aside>
		</main>
	</div>
</template>

<script>
	import wsService from '@/utils/websocketService'
	import { getScreenScale } from '@/utils/rem'
	export default {
		name: 'SmartParkDashboard',
		props: {
			footerIndex: {
				type: [Number, String],
				default: 0,
				required: false,
			}
		},
		data() {
			return {
				dateKey: 'day',
				dateData: [{
						key: 'day',
						label: '日'
					},
					{
						key: 'week',
						label: '周'
					},
					{
						key: 'month',
						label: '月'
					},
				],
				area_overviewData: {},
				factor_trendData: {},
				distribution: {},
				factorsObj: {},
				deviceCode: null,
				factorCode: null,
				totalDeviceCount: 0, // 设备总数（用于中心文字）
			}
		},
		computed: {
			// 正常在线设备数：devices[].status === '1'
			onlineDeviceCount() {
				const devices = this.factorsObj && this.factorsObj.devices;
				if (!Array.isArray(devices)) return 0;
				return devices.filter(d => String(d.status) === '1').length;
			},
			// 异常待整改数：status 为 2故障 / 3告警 / 4离线
			abnormalDeviceCount() {
				const devices = this.factorsObj && this.factorsObj.devices;
				if (!Array.isArray(devices)) return 0;
				return devices.filter(d => ['2', '3', '4'].includes(String(d.status))).length;
			}
		},
	mounted() {
		// if (localStorage.getItem("token")) {
			this.initPieChart()
			this.area_overview()
		// }
		// 初始化设备 WebSocket
		// wsService.initDeviceWs(this.handleDeviceMessage)
		// 窗口尺寸变化时重新渲染环形图（中心字号随屏幕缩放自适应）
		this._onResize = () => this.renderPieChart();
		window.addEventListener('resize', this._onResize);
	},
	beforeDestroy() {
		// wsService.unsubscribeDevice(this.handleDeviceMessage)
		if (this._onResize) window.removeEventListener('resize', this._onResize);
	},
	watch: {
		// 父组件（model.vue 点标注点）改了 footerIndex 时，同步切换 tab 数据 + 折线图
		footerIndex(newVal) {
			if (!newVal || !this.area_overviewData || !this.area_overviewData.areas) return;
			const item = this.area_overviewData.areas.find(a => a.areaId === newVal);
			if (!item) return;
			this.factorsObj = item;
			if (item.factors && item.factors.length) {
				this.deviceCode = item.factors[0].deviceCode;
				this.factorCode = item.factors[0].factorCode;
				this.initLineChart();
			}
		}
	},
		methods: {
			getDeviceCode(item){
				console.log(item,'1577777777')
				this.deviceCode = item.deviceCode;
				this.factorCode = item.factorCode;
				this.initLineChart()
			},
			// 取因子项状态：优先 item.status，兜底通过 deviceCode 关联 factorsObj.devices[].status
			getFactorStatus(item) {
				let status = item && item.status;
				if (status === undefined || status === null) {
					const devices = this.factorsObj && this.factorsObj.devices;
					if (Array.isArray(devices) && item && item.deviceCode) {
						const dev = devices.find(d => d.deviceCode === item.deviceCode);
						if (dev) status = dev.status;
					}
				}
				return status;
			},
			// 是否异常：status 2故障/3告警/4离线
			isFactorAbnormal(item) {
				return ['2', '3', '4'].includes(String(this.getFactorStatus(item)));
			},
			// 因子项状态样式：异常 → 红色背景
			getFactorStatusClass(item) {
				return this.isFactorAbnormal(item) ? 'abnormal' : '';
			},
			// 处理设备数据 WebSocket 消息
			handleDeviceMessage(message) {
				// console.log('[parkOverviewLeft] 收到设备数据推送:', message)
				// 刷新区域概览和环境数据
				this.area_overview()
				this.initLineChart()
				this.initPieChart()
			},
			dateClick(key) {
				this.dateKey = key;
				this.initLineChart()
			},
			tabClick(item) {
				this.factorsObj = item;
				this.$emit('footerIndexChange', item)
			},
	area_overview() {
		this.$http.get(this.$api.BASE_URL_Category.area_overview).then(res => {
			this.area_overviewData = res.data;
			// 把 area 数据传给父组件 model.vue，用于标注点联动和颜色更新
			this.$emit('areaData', res.data);
			if (res.data && res.data.areas && res.data.areas.length) {
				// 优先按父组件传入的 footerIndex 选中对应 area（处理"先点标注点再加载"的时序）
				let target = null;
				if (this.footerIndex) {
					target = res.data.areas.find(a => a.areaId === this.footerIndex);
				}
				if (!target) target = res.data.areas[0];
				this.factorsObj = target;
				if (target.factors && target.factors.length) {
					this.deviceCode = target.factors[0].deviceCode
					this.factorCode = target.factors[0].factorCode
				}
			}
				this.initLineChart()
			})
		},
			// 设备分布环形图
			initPieChart() {
				this.$http.get(this.$api.BASE_URL_Category.devices_overview).then(res => {
					this.distribution = res.data.distribution;
					this.totalDeviceCount = res.data.total;
					this.renderPieChart();
				})
			},
			// 渲染设备分布环形图（中心字号随屏幕缩放自适应）
			renderPieChart() {
				if (!this.$refs.pieChart) return;
				const scale = getScreenScale();
				if (!this.pieChart) {
					this.pieChart = this.$echarts.init(this.$refs.pieChart);
				} else {
					this.pieChart.resize();
				}
				const option = {
					tooltip: {
						trigger: 'item'
					},
					legend: {
						show: false
					},
					grid: {
						left: 8,
						top: 8,
						right: 8,
						bottom: 8
					},
					series: [{
						name: '设备分布',
						type: 'pie',
						radius: ['45%', '80%'],
						center: ['50%', '50%'],
						avoidLabelOverlap: false,
						label: {
							show: true,
							position: 'center',
							formatter: `{a|${this.totalDeviceCount}}\n{b|总设备数}`,
							rich: {
								a: {
									color: '#B3C8DC',
									fontSize: Math.round(24 * scale),
									lineHeight: Math.round(20 * scale)
								},
								b: {
									color: '#ccc',
									fontSize: Math.round(10 * scale),
									lineHeight: Math.round(16 * scale)
								}
							}
						},
						labelLine: {
							show: false
						},
						data: [{
								value: this.distribution.normalDeviceCount,
								name: '正常设备',
								itemStyle: {
									color: '#4A98F7'
								}
							},
							{
								value: this.distribution.abnormalDeviceCount,
								name: '异常设备',
								itemStyle: {
									color: '#36D1D1'
								}
							},
							{
								value: this.distribution.videoDeviceCount,
								name: '视频设备',
								itemStyle: {
									color: '#FFC107'
								}
							},
							{
								value: this.distribution.offlineDeviceCount,
								name: '离线设备',
								itemStyle: {
									color: '#9C51E0'
								}
							}
						]
					}]
				}
				this.pieChart.setOption(option)
			},
			// 温度折线图
			initLineChart() {
				this.$http.get(this.$api.BASE_URL_Category.factor_trend, {
					deviceCode: this.deviceCode,
					factorCode: this.factorCode,
					dateType: this.dateKey
				}).then(res => {
					this.factor_trendData = res.data;
					const scale = getScreenScale();
					const myChart = this.$echarts.init(this.$refs.lineChart)
					const option = {
						tooltip: {
							trigger: 'axis',
							textStyle: {
								fontSize: Math.round(14 * scale)
							}
						},
						grid: {
							// 四向边距随屏幕等比缩放（与字号同乘 scale），
							// 任何分辨率下布局比例一致，标签不会被裁切/溢出
							top: Math.round(8 * scale),
							left: Math.round(55 * scale),
							right: Math.round(10 * scale),
							bottom: Math.round(65 * scale),
							containLabel: false
						},
						xAxis: {
							type: 'category',
							boundaryGap: false,
							data: res.data.times,
							axisLine: {
								lineStyle: {
									color: '#333'
								}
							},
							axisLabel: {
								interval: 0,
								color: '#888',
								fontSize: Math.round(12 * scale),
								rotate: 30,
								margin: 10
							}
						},
						yAxis: {
							type: 'value',
							min: 0,
							axisLine: {
								show: false
							},
							splitLine: {
								lineStyle: {
									color: '#333'
								}
							},
							axisLabel: {
								color: '#888',
								fontSize: Math.round(14 * scale),
								margin: 8
							}
						},
						series: [{
							data: res.data.values,
							type: 'line',
							smooth: true,
							symbol: 'circle',
							symbolSize: 5,
							itemStyle: {
								color: '#4A98F7'
							},
							areaStyle: {
								color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgba(74, 152, 247, 0.4)'
									},
									{
										offset: 1,
										color: 'rgba(74, 152, 247, 0)'
									}
								])
							},
							lineStyle: {
								color: '#4A98F7',
								width: 2
							}
						}]
					}
					myChart.setOption(option)
					window.addEventListener('resize', () => myChart.resize())
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.dashboard-container {
		width: 420px;
		position: absolute;
		top: 90px;
		left: 10px;
		z-index: 2;
		height: 100%;
		color: #B3C8DC;
		font-size: 14px;

		.main-content {

			.left-panel {
				width: 100%;
				display: flex;
				flex-direction: column;
				gap: 10px;
			}
		}

		.panel-section1 {
			height: 206px;
		}

		.panel-section2 {
			height: 763px;
		}

		.panel-section {
			background: rgba(#091724, 0.8);
					// border: 1px solid #4578A8;
			border-radius: 12px;
			padding: 12px;

			.section-title {
				font-size: 16px;
				color: #B3C8DC;
			}

			.section-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 15px;

				.time-label {
					color: #888;
					font-size: 12px;
				}

				.chart-tabs {
					display: flex;
					gap: 10px;

					.tab {
						cursor: pointer;
						padding: 4px 8px;
						border-radius: 4px;
						color: #ccc;
						font-size: 12px;

						&.active {
							background: #4A98F7;
							color: #B3C8DC;
						}
					}
				}
			}

			.device-content {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.chart-wrapper {
					width: 190px;
					height: 160px;

					.echarts-pie {
						width: 100%;
						height: 100%;
					}
				}

				.legend-list {

					.legend-item {
						display: flex;
						align-items: center;
						margin-top: 22px;
						font-size: 12px;

						.dot {
							width: 8px;
							height: 8px;
							border-radius: 50%;
							margin-right: 3px;

							&.normal {
								background: #4A98F7;
							}

							&.abnormal {
								background: #36D1D1;
							}

							&.video {
								background: #FFC107;
							}

							&.offline {
								background: #9C51E0;
							}
						}

						.label {
							color: rgba(255, 255, 255, 0.7);
							margin-right: 40px;
							font-size: 10px;
						}

						.value {
							font-size: 12px;
							color: #B3C8DC;
						}
					}
				}
			}

			.tab-list {
				display: flex;
				justify-content: space-between;
				gap: 8px;
				margin-bottom: 15px;

				.tab-item {
					cursor: pointer;
					padding: 8px 15px;
					background: #172434;
					border-radius: 6px;
					color: #B3C8DC;
					border: 1px solid #2C3D52;

					&.active {
						background: #349DFF;
						color: #B3C8DC;
						border-color: #7ABFFF;
					}
				}
			}

			.top-cards {
				display: flex;
				padding: 15px 0;
				justify-content: space-between;
				border-top: 1px solid #3C5E7D;

				.top-card {
					width: 33.3%;
					text-align: center;
					border-right: 1px solid #25394C;

					.card-num {
						color: #D2E9FF;
						margin-bottom: 5px;
						font-size: 24px;

						span {
							font-size: 10px;
							color: #B3C8DCFFF;
						}
					}

					.card-desc {
						font-size: 10px;
						color: #B3C8DCFFF;
					}
				}

				.top-card:last-child {
					border: none;
				}
			}

			.data-grid {
				display: grid;
				width: 100%;
				height: 400px;
				padding: 5px;
				overflow: hidden;
				grid-template-columns: 1fr 1fr;
				gap: 10px;
				margin-bottom: 15px;

				.grid-item {
					height: 71px;
					padding: 7px 9px;
					background: linear-gradient(0deg, #081724 0%, #16283A 100%);
					border-radius: 8px;
							// border: 1px solid #4578A8;
					position: relative;
					text-align: center;
					cursor: pointer;

					&.warning {
						background: rgba(255, 193, 7, 0.2);
						border: 1px solid #FFC107;

						.value {
							color: #FFC107;
						}
					}

					// 异常状态（2故障/3告警/4离线）：红色背景
					&.abnormal {
						background: rgba(255, 74, 74, 0.2);
						border: 1px solid #FF4A4A;

						.title {
							color: #FF4A4A;
						}

						.value {
							color: #FF4A4A;
						}
					}

					.item-header {
						margin-bottom: 6px;
						text-align: center;

						.title {
							font-weight: 500;
							font-size: 10px;
							color: #B3C8DC;
						}

						.tag {
							position: absolute;
							top: -1px;
							right: -1px;
							width: 37px;
							height: 18px;
							line-height: 14px;
							text-align: center;
							color: #B3C8DCFFF;
							font-size: 10px;
							background: linear-gradient(180deg, #091825 0%, #50A4FC 100%);
							border-radius: 0px 6px 0px 6px;
							border: 1px solid #7ABFFF;
						}
					}

					.value {
						line-height: 38px;
						font-weight: 800;
						font-size: 18px;
						color: #B3C8DCFFF;
						// margin: 8px 0;
					}

					.desc {
						font-weight: 500;
						font-size: 10px;
						color: #B3C8DC;
					}
				}
			}

			.chart-section {
				.chart-tabs {
					display: flex;
					justify-content: flex-end;
					margin-bottom: 10px;
					gap: 8px;

					.tab {
						cursor: pointer;
						padding: 4px 8px;
						border-radius: 4px;
						color: #ccc;
						font-size: 10px;

						&.active {
							background: #4A98F7;
							color: #B3C8DC;
						}
					}
				}

				.echarts-line {
					width: 100%;
					height: 180px;
				}
			}
		}
	}
</style>